var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCubs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1167.43 140.425L1215.68 112.069L1154.63 78.8984L1141.43 141.792L1167.43 140.425Z",
    fill: "#00538c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.38 21.3555V108.622L1141.43 141.792V54.5261L1080.38 21.3555Z",
    fill: "#004E82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.43 54.5254V141.791L1189.68 113.436V26.1699L1141.43 54.5254Z",
    fill: "#01588C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.43 54.5261L1189.68 26.1706L1128.63 -7L1080.38 21.3555L1141.43 54.5261Z",
    fill: "#04649E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.11 244.75L1253.1 205.397L1198.42 175.674L1158.68 244.75H1186.11Z",
    fill: "#00538c"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1104 181.916V215.027L1158.68 244.75V211.639L1104 181.916Z",
    fill: "#004E82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.68 211.638V244.749L1225.67 205.396V172.285L1158.68 211.638Z",
    fill: "#01588C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.68 211.638L1225.67 172.285L1171 142.562L1104 181.915L1158.68 211.638Z",
    fill: "#04649E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.36 185.154L1477.6 85.2151L1397.46 33.8047L1237.06 128.052L1285.88 180.395L1310.36 185.154Z",
    fill: "#00538c"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.81 95.1582V140.156L1285.88 181.493V136.495L1209.81 95.1582Z",
    fill: "#004E82"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.87 136.497V181.495L1446.28 87.2474V42.3086L1285.87 136.497Z",
    fill: "#01588C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.87 136.498L1446.28 42.3097L1370.21 0.914062L1209.81 95.1615L1285.87 136.498Z",
    fill: "#04649E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.662 807.659L285.143 770.387L132.895 687.639L194.234 807.659H221.662Z",
    fill: "#00538c"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9869 686.273V724.913L194.234 807.661V769.022L41.9869 686.273Z",
    fill: "#004E82"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M194.234 769.018V807.658L257.715 770.386V731.746L194.234 769.018Z",
    fill: "#01588C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M194.234 769.021L257.715 731.808L105.408 649L41.9864 686.272L194.234 769.021Z",
    fill: "#04649E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7826 879.528L136.348 828.702L26.8176 769.078L27.2341 879.766L49.7826 879.528Z",
    fill: "#00538c"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-56.3559 737.158V834.292L27.2344 879.768V782.575L-56.3559 737.158Z",
    fill: "#004E82"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2338 782.574V879.767L113.799 828.941V731.748L27.2338 782.574Z",
    fill: "#01588C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2338 782.633L113.799 731.747L30.149 686.271L-56.416 737.157L27.2338 782.633Z",
    fill: "#04649E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M229.812 947.597L391.281 852.722L314.652 811.051L202.385 947.597H229.812Z",
    fill: "#00538c"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.757 860.629V905.926L202.387 947.598V902.3L125.757 860.629Z",
    fill: "#004E82"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M202.385 902.299V947.596L363.795 852.721V807.424L202.385 902.299Z",
    fill: "#01588C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M202.385 902.299L363.795 807.424L287.225 765.812L125.756 860.628L202.385 902.299Z",
    fill: "#04649E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M327.682 1039.91L434.297 977.255L350.826 931.898L300.255 1041.93L327.682 1039.91Z",
    fill: "#00538c"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M216.785 947.178V996.518L300.256 1041.93V992.535L216.785 947.178Z",
    fill: "#004E82"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M300.256 992.533V1041.93L406.871 979.276V929.877L300.256 992.533Z",
    fill: "#01588C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M300.256 992.534L406.871 929.878L323.4 884.521L216.785 947.177L300.256 992.534Z",
    fill: "#04649E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.379 1066.6L176.805 1020L76.3178 965.367L70.0113 1067.67L97.379 1066.6Z",
    fill: "#00538c"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M-30.4751 900.096V1013.04L70.0117 1067.67V954.726L-30.4751 900.096Z",
    fill: "#004E82"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0117 954.724V1067.67L149.318 1021.07V908.119L70.0117 954.724Z",
    fill: "#01588C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9522 954.726L149.318 908.121L48.891 853.49L-30.4752 900.096L69.9522 954.726Z",
    fill: "#04649E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.1 354.426L1274.15 315.014L1219.48 285.291L1179.67 354.426H1207.1Z",
    fill: "#00538c"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1125 291.594V324.705L1179.68 354.428V321.317L1125 291.594Z",
    fill: "#004E82"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.68 321.315V354.426L1246.73 315.013V281.902L1179.68 321.315Z",
    fill: "#01588C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.68 321.315L1246.67 281.902L1191.99 252.18L1125 291.592L1179.68 321.315Z",
    fill: "#04649E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1380.53 99.0488V209.974L1470.37 261.692V150.826L1380.53 99.0488Z",
    fill: "#004E82"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1470.37 150.823L1609.46 70.572L1519.63 18.7949L1380.53 99.0464L1470.37 150.823Z",
    fill: "#04649E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.01 328.208L1455.49 290.936L1303.24 208.188L1364.58 327.257L1392.01 328.208Z",
    fill: "#00538c"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.14 218.83V257.41L1364.59 327.259V288.679L1236.14 218.83Z",
    fill: "#004E82"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.59 288.679V327.259L1428.07 290.046V251.406L1364.59 288.679Z",
    fill: "#01588C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.59 288.678L1428.07 251.405L1299.56 181.557L1236.08 218.829L1364.59 288.678Z",
    fill: "#04649E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubs);
export default __webpack_public_path__ + "static/media/Cubs.87cfb73311304e2a8d854053bbf26ff2.svg";
export { ForwardRef as ReactComponent };